import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './home/login/login.component';
import { LoginGuard } from './core/auth/login.guard';
import { DashComponent } from './home/dash/dash.component';
import { NotLoggedGuard } from './core/auth/not-logged.guard';
import { PasswordRecoveryComponent } from './home/password-recovery/password-recovery.component';
import { AuthCallbackComponent } from './home/auth-callback/auth-callback.component';
import { ParticipantesComponent } from './home/participantes/participantes.component';
import { ParticipantesEditComponent } from './home/participantes/participantes-edit/participantes-edit.component';
import { ClientesComponent } from './home/clientes/clientes.component';
import { ClientesEditComponent } from './home/clientes/clientes-edit/clientes-edit.component';
import { MascarasComponent } from './home/mascaras/mascaras.component';
import { MascarasEditComponent } from './home/mascaras/mascaras-edit/mascaras-edit.component';
import { ProdutosComponent } from './home/produtos/produtos.component';
import { ProdutosEditComponent } from './home/produtos/produtos-edit/produtos-edit.component';
import { EnquadramentoLegalComponent } from './home/enquadramento-legal/enquadramento-legal.component';
import { EnquadramentoLegalEditComponent } from './home/enquadramento-legal/enquadramento-legal-edit/enquadramento-legal-edit.component';
import { NotasFiscaisComponent } from './home/notas-fiscais/notas-fiscais.component';
import { NotasFiscaisEditComponent } from './home/notas-fiscais/notas-fiscais-edit/notas-fiscais-edit.component';
import { ImportacoesComponent } from './home/importacoes/importacoes.component';
import { CargaInicialImportacoesComponent } from './home/carga-inicial/carga-inicial.component';
import { MovimentacoesImportacoesComponent } from './home/movimentacao/movimentacao.component';
import { OrdemProducaoComponent } from './home/ordem-producao/ordem-producao.component';
import { OrdemProducaoEditComponent } from './home/ordem-producao/ordem-producao-edit/ordem-producao-edit.component';
import { OrdemProducaoOutrosEstabComponent } from './home/ordem-producao-outros-estab/ordem-producao-outros-estab.component';
import { OrdemProducaoOutrosEstabEditComponent } from './home/ordem-producao-outros-estab/ordem-producao-outros-estab-edit/ordem-producao-outros-estab-edit.component';
import { CfopsComponent } from './home/cfops/cfops.component';
import { CfopEditComponent } from './home/cfops/cfops-edit/cfop-edit.component';
import { AjusteEstoqueComponent } from './home/ajuste-estoque/ajuste-estoque.component';
import { AjusteEstoqueEditComponent } from './home/ajuste-estoque/ajuste-estoque-edit/ajuste-estoque-edit.component';
import { InventarioComponent } from './home/inventario/inventario.component';
import { InventarioEditComponent } from './home/inventario/inventario-edit/inventario-edit.component';
import { EstornosComponent } from './home/estornos/estornos.component';
import { EstornosEditComponent } from './home/estornos/estornos-edit/estornos-edit.component';
import { TransferenciaFichasComponent } from './home/transferencia-fichas/transferencia-fichas.component';
import { TransferenciaFichasEditComponent } from './home/transferencia-fichas/transferencia-fichas-edit/transferencia-fichas-edit.component';
import { CfopsDevolucaoComponent } from './home/cfops-devolucao/cfops-devolucao.component';
import { CfopsDevolucaoEditComponent } from './home/cfops-devolucao/cfops-devolucao-edit/cfops-devolucao-edit.component';
import { DevolucaoComponent } from './home/devolucao/devolucao.component';
import { DevolucaoEditComponent } from './home/devolucao/devolucao-edit/devolucao-edit.component';
import { RateioEnergiaComponent } from './home/rateio-energia/rateio-energia.component';
import { RateioEnergiaEditComponent } from './home/rateio-energia/rateio-energia-edit/rateio-energia-edit.component';
import { CodigosInternosComponent } from './home/codigos-internos/codigos-internos.component';
import { CodigosInternosEditComponent } from './home/codigos-internos/codigos-internos-edit/codigos-internos-edit.component';
import { CodigoLancamentoComponent } from './home/codigo-lancamento/codigo-lancamento.component';
import { CodigoLancamentoEditComponent } from './home/codigo-lancamento/codigo-lancamento-edit/codigo-lancamento-edit.component';
import { DespachosComponent } from './home/despachos/despachos.component';
import { DespachosEditComponent } from './home/despachos/despachos-edit/despachos-edit.component';
import { ProcessamentoFichasComponent } from './home/processamento-fichas/processamento-fichas.component';
import { ProcessamentosFichasNovoComponent } from './home/processamento-fichas/novo/novo.component';
import { ComparacaoArquivosComponent } from './home/comparacao-arquivos/comparacao-arquivos.component';
import { ProcessosComponent } from './home/processos/processos.component';
import { UserComponent } from './home/user/user.component';

const routes: Routes = [

  {
    path: '',
    component: LoginComponent,
    canActivate: [LoginGuard]
  },
  {
    path: 'password-recovery',
    component: PasswordRecoveryComponent
  },
  {
    path: 'home',
    component: DashComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'participantes',
    component: ParticipantesComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'participantes-edit/:id',
    component: ParticipantesEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'participantes-edit',
    component: ParticipantesEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'clientes',
    component: ClientesComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'clientes-edit/:id',
    component: ClientesEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'clientes-edit',
    component: ClientesEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'mascaras',
    component: MascarasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'mascaras-edit/:id',
    component: MascarasEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'mascaras-edit',
    component: MascarasEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'enquadramento-legal',
    component: EnquadramentoLegalComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'enquadramento-legal-edit/:id',
    component: EnquadramentoLegalEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'enquadramento-legal-edit',
    component: EnquadramentoLegalEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'produtos',
    component: ProdutosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'produtos-edit/:id',
    component: ProdutosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'produtos-edit',
    component: ProdutosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'ordem-producao',
    component: OrdemProducaoComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'ordem-producao-edit/:id',
    component: OrdemProducaoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'ordem-producao-edit',
    component: OrdemProducaoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'ordem-producao-outros-estab',
    component: OrdemProducaoOutrosEstabComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'ordem-producao-outros-estab-edit/:id',
    component: OrdemProducaoOutrosEstabEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'ordem-producao-outros-estab-edit',
    component: OrdemProducaoOutrosEstabEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'auth/callback',
    component: AuthCallbackComponent
  },
  {
    path: 'nf',
    component: NotasFiscaisComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'nf-edit/:id',
    component: NotasFiscaisEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'nf-edit',
    component: NotasFiscaisEditComponent,
  },
  {
    path: 'importacoes/carga-inicial',
    component: CargaInicialImportacoesComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'importacoes/movimentacao',
    component: MovimentacoesImportacoesComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'cfops',
    component: CfopsComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'cfops-edit/:id',
    component: CfopEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'cfops-edit',
    component: CfopEditComponent,
  },
  {
    path: 'ajuste-estoque',
    component: AjusteEstoqueComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'ajuste-estoque-edit/:id',
    component: AjusteEstoqueEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'ajuste-estoque-edit',
    component: AjusteEstoqueEditComponent,
  },
  {
    path: 'inventario',
    component: InventarioComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'inventario-edit/:id',
    component: InventarioEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'inventario-edit',
    component: InventarioEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'estornos',
    component: EstornosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'estornos-edit/:id',
    component: EstornosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'estornos-edit',
    component: EstornosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'transferencia-fichas',
    component: TransferenciaFichasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'transferencia-fichas-edit/:id',
    component: TransferenciaFichasEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'transferencia-fichas-edit',
    component: TransferenciaFichasEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'cfops-devolucao',
    component: CfopsDevolucaoComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'cfops-devolucao-edit/:id',
    component: CfopsDevolucaoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'cfops-devolucao-edit',
    component: CfopsDevolucaoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'devolucao',
    component: DevolucaoComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'devolucao-edit/:id',
    component: DevolucaoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'devolucao-edit',
    component: DevolucaoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'despachos',
    component: DespachosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'despachos-edit/:id',
    component: DespachosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'despachos-edit',
    component: DespachosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'rateio-energia',
    component: RateioEnergiaComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'rateio-energia-edit/:id',
    component: RateioEnergiaEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'rateio-energia-edit',
    component: RateioEnergiaEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'codigos-internos',
    component: CodigosInternosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'codigos-internos-edit/:id',
    component: CodigosInternosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'codigos-internos-edit',
    component: CodigosInternosEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'codigo-lancamento',
    component: CodigoLancamentoComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'codigo-lancamento-edit/:id',
    component: CodigoLancamentoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'codigo-lancamento-edit',
    component: CodigoLancamentoEditComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'processamento-fichas',
    component: ProcessamentoFichasComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'processamento-fichas/novo',
    component: ProcessamentosFichasNovoComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'comparacao-arquivos',
    component: ComparacaoArquivosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'processos',
    component: ProcessosComponent,
    canActivate: [NotLoggedGuard]
  },
  {
    path: 'usuarios',
    component: UserComponent,
    canActivate: [NotLoggedGuard]
  }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
